

export default cjs;
import hasOwnProp from 'utils/hasOwnProp';
import packageResult from 'utils/packageResult';
import { req } from 'utils/mappers';
function cjs(mod, options) {
	var seen = {};

	mod.imports.forEach(function (x) {
		if (!hasOwnProp.call(seen, x.path)) {
			var replacement = x.isEmpty ? req(x.path) + ';' : 'var ' + x.as + ' = ' + req(x.path) + ';';
			mod.body.replace(x.start, x.end, replacement);

			seen[x.path] = true;
		} else {
			mod.body.remove(x.start, x.next);
		}
	});

	var exportDeclaration = mod.exports[0];

	if (exportDeclaration) {
		switch (exportDeclaration.type) {
			case 'namedFunction':
			case 'namedClass':
				mod.body.remove(exportDeclaration.start, exportDeclaration.valueStart);
				mod.body.replace(exportDeclaration.end, exportDeclaration.end, '\nmodule.exports = ' + exportDeclaration.name + ';');
				break;

			default:
				mod.body.replace(exportDeclaration.start, exportDeclaration.valueStart, 'module.exports = ');
				break;
		}
	}

	if (options.useStrict !== false) {
		mod.body.prepend("'use strict';\n\n").trimLines();
	}

	return packageResult(mod, mod.body, options, 'toCjs');
}
//# sourceMappingURL=/www/ESPERANTO/esperanto/.gobble-build/01-babel/1/standalone/builders/defaultsMode/cjs.js.01-babel.map